export default __webpack_public_path__ + "static/bg-section-2-793cf054cecd8a718cd5bef6812ba5b4.svg";